const customEvents = {
    event_ice_failed: {
        event_code: '4000', severity: 'critical', event_name: 'ice-failed', event_description: 'ICE failed',
    },
    event_ice_success: {
        event_code: '40001', severity: '', event_name: 'ice-success', event_description: 'ICE success',
    },
    event_stream_subscribe_failed: {
        event_code: '4001', severity: 'critical', event_name: 'stream-subscribe-failed', event_description: 'Failed to subscribe to stream',
    },
    event_stream_subscribe_success: {
        event_code: '40011', severity: '', event_name: 'stream-subscribe-success', event_description: 'Subscribe to stream successful',
    },
    event_stream_unsubscribe_failed: {
        event_code: '4002', severity: 'critical', event_name: 'stream-unsubscribe-failed', event_description: 'Failed to unsubscribe from stream',
    },
    event_stream_unsubscribe_success: {
        event_code: '40021', severity: '', event_name: 'stream-unsubscribe-success', event_description: 'Unsubscribe from stream success',
    },
    event_socket_connect_failed: {
        event_code: '4003', severity: 'critical', event_name: 'socket-connect-failed', event_description: 'Socket connection failed',
    },
    event_socket_connect_success: {
        event_code: '40031', severity: '', event_name: 'socket-connect-success', event_description: 'Socket connection successful',
    },
    event_stream_publish_failed: {
        event_code: '4004', severity: 'critical', event_name: 'stream-publish-failed', event_description: 'Failed to publish stream',
    },
    event_stream_publish_success: {
        event_code: '40041', severity: '', event_name: 'stream-publish-success', event_description: 'stream published successfully',
    },
    event_stream_unpublish_failed: {
        event_code: '4005', severity: 'critical', event_name: 'stream-unpublish-failed', event_description: 'Failed to unpublish stream',
    },
    event_stream_unpublish_success: {
        event_code: '40051', severity: '', event_name: 'stream-unpublish-success', event_description: 'Unpublish stream success',
    },
    event_start_recording_failed: {
        event_code: '4006', severity: 'critical', event_name: 'start-recording-failed', event_description: 'Failed to start recording',
    },
    event_start_recording_success: {
        event_code: '40061', severity: '', event_name: 'start-recording-success', event_description: 'Start recording success',
    },
    event_start_local_recording_failed: {
        event_code: '40062', severity: 'critical', event_name: 'start-local-recording-failed', event_description: 'Failed to start local recording',
    },
    event_start_local_recording_success: {
        event_code: '40063', severity: '', event_name: 'start-local-recording-success', event_description: 'Start local recording success',
    },
    event_stop_recording_failed: {
        event_code: '4007', severity: 'critical', event_name: 'stop-recording-failed', event_description: 'Failed to stop recording',
    },
    event_stop_recording_success: {
        event_code: '40071', severity: '', event_name: 'stop-recording-success', event_description: 'Stop recording success',
    },
    event_stop_local_recording_failed: {
        event_code: '40072', severity: 'critical', event_name: 'stop-local-recording-failed', event_description: 'Failed to stop local recording',
    },
    event_stop_local_recording_success: {
        event_code: '40073', severity: '', event_name: 'stop-local-recording-success', event_description: 'Stop local recording success',
    },
    event_start_screenshare_failed: {
        event_code: '4008', severity: 'critical', event_name: 'start-screenshare-failed', event_description: 'Failed to start screenshare',
    },
    event_start_screenshare_success: {
        event_code: '40081', severity: '', event_name: 'start-screenshare-success', event_description: 'Screenshare Start successfully',
    },
    event_stop_screenshare_failed: {
        event_code: '4009', severity: 'critical', event_name: 'stop-screenshare-failed', event_description: 'Failed to stop screenshare',
    },
    event_stop_screenshare_success: {
        event_code: '40091', severity: '', event_name: 'stop-screenshare-success', event_description: 'Screenshare stopped successfully',
    },
    event_start_canvas_failed: {
        event_code: '4010', severity: 'critical', event_name: 'start-canvas-failed', event_description: 'Failed to start canvas',
    },
    event_start_canvas_success: {
        event_code: '40101', severity: '', event_name: 'start-canvas-success', event_description: 'Canvas started successfully',
    },
    event_stop_canvas_failed: {
        event_code: '4011', severity: 'critical', event_name: 'stop-canvas-failed', event_description: 'Failed to stop canvas',
    },
    event_stop_canvas_success: {
        event_code: '40111', severity: '', event_name: 'stop-canvas-success', event_description: 'Canvas stopped successfully',
    },
    event_network_reconnect_timeout: {
        event_code: '4012', severity: 'high', event_name: 'network-reconnect-timeout', event_description: 'Reconnection timed out',
    },
    event_start_annotation_failed: {
        event_code: '4012', severity: 'high', event_name: 'start-annotation-failed', event_description: 'Start Annotation Failed',
    },
    event_start_annotation_success: {
        event_code: '40121', severity: 'high', event_name: 'start-annotation-success', event_description: 'Start Annotation successful',
    },
    event_stop_annotation_failed: {
        event_code: '4013', severity: 'high', event_name: 'stop-annotation-failed', event_description: 'Stop Annotation Failed',
    },
    event_stop_annotation_success: {
        event_code: '40131', severity: 'high', event_name: 'stop-annotation-success', event_description: 'Stop Annotation successful',
    },
    event_send_message_failed: {
        event_code: '4013', severity: 'high', event_name: 'send-message-failed', event_description: 'Failed to send message',
    },
    event_send_message_success: {
        event_code: '40131', severity: '', event_name: 'send-message-success', event_description: 'Send message success',
    },
    event_reconnect_socket_failed: {
        event_code: '4014', severity: 'high', event_name: 'reconnect-socket-failed', event_description: 'Failed to reconnect socket',
    },
    event_reconnect_socket_success: {
        event_code: '40141', severity: '', event_name: 'reconnect-socket-success', event_description: 'Socket reconnection success',
    },
    event_send_data_failed: {
        event_code: '4018', severity: 'high', event_name: 'send-data-failed', event_description: 'Failed to send data',
    },
    event_send_data_success: {
        event_code: '40181', severity: '', event_name: 'send-data-success', event_description: 'Send data success',
    },
    event_media_access_denied: {
        event_code: '4019', severity: 'critical', event_name: 'media-access-denied', event_description: 'Access to media denied',
    },
    event_media_access_success: {
        event_code: '40191', severity: '', event_name: 'media-access-allowed-success', event_description: 'User has granted access to local media.',
    },
    event_agent_media_access_denied: {
        event_code: '40192', severity: 'critical', event_name: 'agent-media-access-denied-failed', event_description: 'Access to media denied (Agent)',
    },
    event_gum_failed: {
        event_code: '4020', severity: 'critical', event_name: 'gum-failed', event_description: 'Get User Media failed',
    },
    event_gum_success: {
        event_code: '40201', severity: '', event_name: 'gum-success', event_description: 'Get User Media success',
    },
    event_agent_gum_failed: {
        event_code: '40201', severity: 'critical', event_name: 'agent-gum-failed', event_description: 'Get User Media failed (Agent)',
    },
    event_audio_device_access_failed: {
        event_code: '4021', severity: 'critical', event_name: 'audio-device-access-failed', event_description: 'Failed to access Audio device',
    },
    event_agent_audio_device_access_failed: {
        event_code: '40211', severity: 'critical', event_name: 'agent-audio-device-access-failed', event_description: 'Failed to access Audio device (Agent)',
    },
    event_video_device_access_failed: {
        event_code: '4022', severity: 'critical', event_name: 'video-device-access-failed', event_description: 'Failed to access Video device',
    },
    event_agent_video_device_access_failed: {
        event_code: '40221', severity: 'critical', event_name: 'agent-video-device-access-failed', event_description: 'Failed to access Video device (Agent)',
    },
    event_remote_canvas_stream_failed: {
        event_code: '4023', severity: 'high', event_name: 'remote-canvas-stream-failed', event_description: 'Remote canvas stream failed',
    },
    event_capture_canvas_stream_failed: {
        event_code: '4024', severity: 'critical', event_name: 'capture-canvas-stream-failed', event_description: 'Failed to capture canvas stream',
    },
    event_set_local_description: {
        event_code: '4025', severity: 'none', event_name: 'set-local-description', event_description: 'Local SDP description is set',
    },
    event_set_remote_description: {
        event_code: '4026', severity: 'none', event_name: 'set-remote-description', event_description: 'Remote SDP description is set',
    },
    event_reconnect_subscribe_failed: {
        event_code: '4027', severity: 'high', event_name: 'reconnect-subscribe-failed', event_description: 'Failed to subscribe while reconnecting',
    },
    event_reconnect_publish_failed: {
        event_code: '4028', severity: 'high', event_name: 'reconnect-publish-failed', event_description: 'Failed to publish while reconnecting',
    },
    event_incompatible_browser: {
        event_code: '4029', severity: 'high', event_name: 'incompatible-browser', event_description: 'Browser is incompatible',
    },
    event_connect_socket_failed: {
        event_code: '4030', severity: 'high', event_name: 'connect-socket-failed', event_description: 'Socket connection failed',
    },
    event_connect_socket_success: {
        event_code: '40301', severity: '', event_name: 'connect-socket-success', event_description: 'Socket connection successful',
    },
    event_room_reconnection_failed: {
        event_code: '4031', severity: 'high', event_name: 'room-reconnection-failed', event_description: 'Room reconnection failed',
    },
    event_room_reconnection_success: {
        event_code: '40311', severity: '', event_name: 'room-reconnection- success', event_description: 'Room reconnection success',
    },
    event_room_disconnection_failed: {
        event_code: '4032', severity: 'high', event_name: 'room-disconnection-failed', event_description: 'Room disconnection failed',
    },
    event_room_disconnection_success: {
        event_code: '40321', severity: '', event_name: 'room-disconnection-success', event_description: 'Room disconnection success',
    },
    event_mute_self_audio_failed: {
        event_code: '4033', severity: 'high', event_name: 'mute-self-audio-failed', event_description: 'mute self audio failed',
    },
    event_mute_self_audio_success: {
        event_code: '40331', severity: '', event_name: 'mute-self-audio-success', event_description: 'mute self audio success',
    },
    event_unmute_self_audio_failed: {
        event_code: '4034', severity: 'high', event_name: 'unmute-self-audio-failed', event_description: 'unmute self audio failed',
    },
    event_unmute_self_audio_success: {
        event_code: '40341', severity: '', event_name: 'unmute-self-audio-success', event_description: 'unmute self audio success',
    },
    event_room_mute_failed: {
        event_code: '4035', severity: 'high', event_name: 'room-mute-failed', event_description: 'room mute failed',
    },
    event_room_mute_success: {
        event_code: '40351', severity: '', event_name: 'room-mute-success', event_description: 'room mute success',
    },
    event_room_unmute_failed: {
        event_code: '4036', severity: 'high', event_name: 'room-unmute-failed', event_description: 'room unmute failed',
    },
    event_room_unmute_success: {
        event_code: '40361', severity: '', event_name: 'room-unmute-success', event_description: 'room unmute success',
    },
    event_file_shared_failed: {
        event_code: '4037', severity: 'high', event_name: 'file-shared-failed', event_description: 'file shared failed',
    },
    event_file_shared_success: {
        event_code: '40371', severity: '', event_name: 'file-shared-success', event_description: 'file shared success',
    },
    event_file_download_failed: {
        event_code: '4038', severity: 'high', event_name: 'file-downlod-failed', event_description: 'file download failed',
    },
    event_file_download_success: {
        event_code: '40381', severity: '', event_name: 'file-downlod-success', event_description: 'file downlod success',
    },
    event_mute_self_video_failed: {
        event_code: '4039', severity: 'high', event_name: 'mute-self-video-failed', event_description: 'mute self video failed',
    },
    event_mute_self_video_success: {
        event_code: '40391', severity: '', event_name: 'mute-self-video-success', event_description: 'mute self video success',
    },
    event_unmute_self_video_failed: {
        event_code: '4040', severity: 'high', event_name: 'unmute-self-video-failed', event_description: 'unmute self video failed',
    },
    event_unmute_self_video_success: {
        event_code: '40401', severity: '', event_name: 'unmute-self-video-success', event_description: 'unmute self video failed',
    },
    event_low_bandwidth_update: {
        event_code: '4041', severity: '', event_name: 'low-bandwidth-update', event_description: 'low bandwidth update',
    },
    event_network_change: {
        event_code: '4042', severity: '', event_name: 'network-change', event_description: 'network change',
    },
    event_connection_lost: {
        event_code: '4043', severity: '', event_name: 'connection-lost', event_description: 'connection lost',
    },
    event_make_outbound_call_failed: {
        event_code: '4044', severity: 'high', event_name: 'make-outbound-call-failed', event_description: 'Outbound call failed',
    },
    event_make_outbound_call_success: {
        event_code: '40441', severity: '', event_name: 'make-outbound-call-success', event_description: 'Outbound call success',
    },
    event_make_outbound_call_state: {
        event_code: '4045', severity: '', event_name: 'make-outbound-call-state', event_description: 'Outbound call state',
    },
    event_abwd_mute_video_success: {
        event_code: '4101', severity: '', event_name: 'mute-publisher-video-success', event_description: 'Publisher video muted due to low bandwidth',
    },
    event_fs_upload_started_success: {
        event_code: '4102', severity: '', event_name: 'fs-upload-started-success', event_description: 'File is being shared',
    },
    event_fs_file_available_success: {
        event_code: '4103', severity: '', event_name: 'fs-file-available-success', event_description: 'File is being shared',
    },
    event_room_user_connect_failed: {
        event_code: '4104', severity: '', event_name: 'room-user-connect-failed', event_description: 'User connection to the Room failed',
    },
    event_room_user_connect_success: {
        event_code: '41041', severity: '', event_name: 'room-user-connect-success', event_description: 'A new user is connected to the Room',
    },
    event_room_user_disconnect_failed: {
        event_code: '4105', severity: '', event_name: 'room-user-disconnect-failed', event_description: 'User disconnection to the Room failed',
    },
    event_room_user_disconnect_success: {
        event_code: '41051', severity: '', event_name: 'room-user-disconnect-success', event_description: 'User is disconnected to the Room',
    },
    event_start_live_recording_failed: {
        event_code: '4046', severity: 'critical', event_name: 'start-live-recording-failed', event_description: 'Failed to start live recording',
    },
    event_start_live_recording_success: {
        event_code: '40461', severity: '', event_name: 'start-live-recording-success', event_description: 'Start live recording success',
    },
    event_stop_live_recording_failed: {
        event_code: '4047', severity: 'critical', event_name: 'stop-live-recording-failed', event_description: 'Failed to stop live recording',
    },
    event_stop_live_recording_success: {
        event_code: '40471', severity: '', event_name: 'stop-live-recording-success', event_description: 'Stop live recording success',
    },
    event_general_failed: {
        event_code: '4106', severity: 'critical', event_name: 'general-failed', event_description: 'General error',
    },
    event_general_success: {
        event_code: '41061', severity: '', event_name: 'general-success', event_description: 'General success',
    },
};

export default customEvents;



//////////////////
// WEBPACK FOOTER
// ./src/customEvents.js
// module id = 9
// module chunks = 0